import { UIUtilStrings } from "../../ui/util/Strings";
import { UIUtilTime } from "../../ui/util/Time";
import { ICicloEscolar, ICicloEscolarPeriodo, IMonthPeriod as IMonthPeriod } from "../entidad/CicloEscolar";
import { ModelAdapter } from "./ModelAdapter";

export class MCicloEscolar extends ModelAdapter<ICicloEscolar> implements ICicloEscolar {
    readonly Id: number;
    readonly IdEscuela: number;
    readonly Nombre: string;
    readonly IdOrganizacion: number;
    readonly FechaInicio: string;
    readonly FechaFin: string;
    readonly Periodos: ICicloEscolarPeriodo[];

    constructor(data: ICicloEscolar) {
        super(data);
    }

    // =================================================
    // METODOS PÚBLICOS
    // =================================================

    public _GetMonthPeriods(onlyBeforeCurrentDate = true): IMonthPeriod[] {
        console.log("_GetMonthPeriods: ", "from Model")
        const currentDateValidator = (onlyBeforeCurrentDate ? UIUtilTime._GetValidatorDateYM(new Date()) : 999999);
        const startDateCicloEscolarValidator = UIUtilTime._GetValidatorDateYM(new Date(this.FechaInicio));
        let auxDateProcesoPeriodo = new Date(this.FechaFin);
        auxDateProcesoPeriodo.setDate(2);
        let procesoPeriodoValidator = UIUtilTime._GetValidatorDateYM(auxDateProcesoPeriodo);
        let periodos: IMonthPeriod[] = [];
        let index = 1;

        while (procesoPeriodoValidator >= startDateCicloEscolarValidator) {
            let periodo: IMonthPeriod = {
                Id: index,
                Month: auxDateProcesoPeriodo.getMonth(),
                Year: auxDateProcesoPeriodo.getFullYear(),
                Name: UIUtilStrings._CapitaliceString(UIUtilTime._DateFormatStandar(auxDateProcesoPeriodo, "MMM yyyy"))
            };
            if (procesoPeriodoValidator <= currentDateValidator) {
                periodos.push(periodo);
            }
            auxDateProcesoPeriodo.setMonth(auxDateProcesoPeriodo.getMonth() - 1);
            procesoPeriodoValidator = UIUtilTime._GetValidatorDateYM(auxDateProcesoPeriodo);
            index++;
        }

        return periodos;
    }

    public _GetPeriodsFromCicloEscolarV2(filter: 'all' | 'before' | 'after' = 'all', sort: 'asc' | 'desc' = 'desc') {
        const periods: IMonthPeriod[] = [];

        const currentDateValidator = UIUtilTime._GetValidatorDateYM(new Date());
        const startDateCicloEscolarValidator = UIUtilTime._GetValidatorDateYM(new Date(this.FechaInicio));

        let auxDateProcesoPeriodo = new Date(this.FechaFin);
        auxDateProcesoPeriodo.setDate(2);
        let procesoPeriodoValidator = UIUtilTime._GetValidatorDateYM(auxDateProcesoPeriodo);
        let index = 1;

        while (procesoPeriodoValidator >= startDateCicloEscolarValidator) {
            let periodValid = true;
            switch (filter) {
                case "before":
                    periodValid = procesoPeriodoValidator <= currentDateValidator;
                    break;
                case "after":
                    periodValid = procesoPeriodoValidator >= currentDateValidator;
                    break;
            }

            if (periodValid) {
                periods.push({
                    Id: index,
                    Month: auxDateProcesoPeriodo.getMonth(),
                    Year: auxDateProcesoPeriodo.getFullYear(),
                    Name: UIUtilStrings._CapitaliceString(UIUtilTime._DateFormatStandar(auxDateProcesoPeriodo, "MMM yyyy")),
                })
            }
            auxDateProcesoPeriodo.setMonth(auxDateProcesoPeriodo.getMonth() - 1);
            procesoPeriodoValidator = UIUtilTime._GetValidatorDateYM(auxDateProcesoPeriodo);
            index++;
        }

        sort == 'asc' && (periods.reverse())
        return periods;
    }
}